import type { ImgHTMLAttributes } from 'react';

/**
 * Prioridad alta de descarga para la imagen principal de una pantalla.
 *
 * Va como objeto para desparramar y no como prop suelta por una diferencia de
 * versiones: `fetchPriority` en camelCase lo entiende React 19, pero el 18 no
 * lo reconoce, lo descarta y deja un error en la consola de cada visita. En
 * minúsculas pasa como atributo tal cual y el navegador lo lee igual.
 *
 * El casteo es porque los tipos de React ya declaran la forma nueva; el runtime
 * de esta versión todavía no. Cuando el proyecto pase a React 19 esto se
 * reemplaza por `fetchPriority="high"` y se borra el archivo.
 */
export const highPriorityImage = { fetchpriority: 'high' } as unknown as ImgHTMLAttributes<
  HTMLImageElement
>;
